/** ngrok's development interstitial is HTML, even for a successful API status. */
export const getDevelopmentApiHeaders = (url?: string): Record<string, string> => {
  if (!url) return {};
  try {
    const target = new URL(url);
    const ngrokDomains = ['ngrok-free.dev', 'ngrok-free.app', 'ngrok.dev', 'ngrok.app', 'ngrok.io'];
    if (target.protocol.toLowerCase() === 'https:' && ngrokDomains.some(domain => target.hostname.toLowerCase().endsWith(`.${domain}`))) {
      return { 'ngrok-skip-browser-warning': 'true' };
    }
  } catch {
    // Relative or invalid URLs retain their existing transport behavior.
  }
  return {};
};
